import React, { useState, useRef } from 'react';
interface MagneticButtonProps {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
  className?: string;
}
export function MagneticButton({
  children,
  variant = 'primary',
  size = 'md',
  onClick,
  className = ''
}: MagneticButtonProps) {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [position, setPosition] = useState({
    x: 0,
    y: 0
  });
  const handleMouseMove = (e: React.MouseEvent<HTMLButtonElement>) => {
    const button = buttonRef.current;
    if (!button) return;
    const rect = button.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;
    setPosition({
      x: x * 0.3,
      y: y * 0.3
    });
  };
  const handleMouseLeave = () => {
    setPosition({
      x: 0,
      y: 0
    });
  };
  const baseStyles = 'relative inline-flex items-center justify-center font-semibold rounded-full transition-all duration-300 overflow-hidden hover:shadow-2xl hover:scale-105 active:scale-100 transform cursor-pointer';
  const variantStyles = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700 shadow-lg hover:shadow-blue-500/50',
    secondary: 'bg-white text-gray-900 hover:bg-gray-50 shadow-lg hover:shadow-gray-500/50',
    outline: 'border-2 border-white text-white hover:bg-white hover:text-gray-900 shadow-lg'
  };
  const sizeStyles = {
    sm: 'text-sm px-6 py-2.5',
    md: 'text-base px-8 py-3.5',
    lg: 'text-lg px-10 py-4'
  };
  return <button ref={buttonRef} className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} onClick={onClick} style={{
    transform: `translate(${position.x}px, ${position.y}px) scale(${position.x || position.y ? 1.05 : 1})`
  }} data-id="element-134">
      <span className="relative z-10" data-id="element-135">{children}</span>
      <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-green-400 opacity-0 group-hover:opacity-20 transition-opacity duration-300" data-id="element-136" />
    </button>;
}